import { quickFetchOrGet } from '../../utils/ajaxUtils';
import { BASE_URI_PROGRESS } from '../../constants/ApiConstants';
import dataFetchingClient from '../../utils/DataFetchingClient';
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
const GET_FILTERS = registerQuery({
  fieldName: 'filters',
  args: [],
  fetcher() {
    return quickFetchOrGet('academy-filters', `${BASE_URI_PROGRESS}/filters`);
  }
});
export const getFilters = () => {
  return dataFetchingClient.queryUnwrapped({
    query: GET_FILTERS
  });
};
export const useFilters = () => {
  const {
    data: filters,
    loading: filtersLoading,
    error: filtersError
  } = useQuery(GET_FILTERS);
  return {
    filters,
    filtersLoading,
    filtersError
  };
};